import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { DatePicker } from 'antd'
import { Remark } from 'components'
import { Table } from '@sar/component'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/orders/production`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

export default function ({ store, navigator }) {
  const columns = [
    {
      title: '项目单号',
      dataIndex: 'number',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'customerSource',
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '负责人',
      dataIndex: 'producerName',
    },
    {
      title: '生产下单时间',
      dataIndex: 'purchaseTime',
    },
    {
      title: '生产类型',
      dataIndex: 'type',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderType`),
    },
    {
      title: '预计交货时间',
      dataIndex: 'estimatedShipmentDate',
      render: (_, data) => React.createElement(() => {
        const [ state, dispatch ] = React.useState(
          // @ts-ignore
          data.estimatedShipmentDate ? dayjs(data.estimatedShipmentDate) : null
        )

        const handleSave = useRequest(
          async () => store.externals.api.put(`/orders/production/${data.id}/time`, {
            params: {
                time: state.format('YYYY-MM-DD HH:mm:ss')
              , type: 'estimatedShipments'
            }
          }),
          {
            manual: true
          }
        )

        if (store.identity.hasPermission('/production/list:update') == false) {
          return _
        }

        return <DatePicker
          showTime={{ format: 'HH:mm' }}
          format='YYYY-MM-DD HH:mm'
          value={state}
          onBlur={handleSave.run}
          onChange={e => dispatch(e)}
        />
      })
    },
    {
      title: '告警时间',
      dataIndex: 'warningTime',
      render: (_, data) => React.createElement(() => {
        const [ state, dispatch ] = React.useState(
          // @ts-ignore
          data.warningTime ? dayjs(data.warningTime) : null
        )

        const handleSave = useRequest(
          async () => store.externals.api.put(`/orders/production/${data.id}/time`, {
            params: {
                time: state.format('YYYY-MM-DD HH:mm:ss')
              , type: 'warning'
            }
          }),
          {
            manual: true
          }
        )

        if (store.identity.hasPermission('/production/list:update') == false) {
          return _
        }

        return <DatePicker
          showTime={{ format: 'HH:mm' }}
          format='YYYY-MM-DD HH:mm'
          value={state}
          onBlur={handleSave.run}
          onChange={e => dispatch(e)}
        />
      })
    },
    {
      title: '生产状态',
      dataIndex: 'purchaseLoading',
    }
  ]

  const rowActions = [
    {
      name: '查看详情',
      visible: () => store.identity.hasPermission('/production/list:detail'),
      onClick: (data) => navigator.to(`/production/list/detail/${data.id}/${data.type}`, `查看生产`)
    },
    {
      name: '确定',
      confirmType: 'modal',
      confirmMessage: '确定后订单会进入装配环节，将不可更改。',
      visible: () => store.identity.hasPermission('/production/list:submit'),
      onConfirm: (data, handles) => store.externals.api.put(`/orders/production/${data.id}`).then(() => handles.current.reload()),
    },
    {
      name: '查看备注',
      form: props => <Remark {...props}/>,
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'customerName'
      , 'customerAddress'
      , 'customerPhone'
      , 'sourceId'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  const onRow = React.useCallback(data => {
    let ignore = [
        'assembling'
      , 'end'
    ]

    if (ignore.includes(data.status)) {
      return null
    }

    else if (data.warningTime == null) {
      return null
    }

    else if (moment().isBefore(data.warningTime, 'day')) {
      return null
    }

    else {
      return {
        className: 'text-red-600'
      }
    }
  }, [])

  return <div className='p-4'>
    <Table
      onRow={onRow}
      title='生产管理列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
    />
  </div>
}
